import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { Spinner, Col, Row } from "reactstrap";
import { useTranslation } from "react-i18next";

const Historique = () => {
  const { t } = useTranslation();
  const { getProfileLoading, player } = useSelector((state) => state.Player);

  // const player = {
  //   result: [{ id: 1 }], // juste pour dire que "result" existe et n'est pas vide
  //   history: [
  //     {
  //       clubName: "FC Barcelone",
  //       dateRange: {
  //         startDate: "2015-07-01",
  //         endDate: "2019-06-30",
  //       },
  //       category: "Senior",
  //       position: "Milieu offensif",
  //       matchesPlayed: 125,
  //       goalsScored: 34,
  //       assists: 21,
  //     },
  //     {
  //       clubName: "Paris Saint-Germain",
  //       dateRange: {
  //         startDate: "2019-07-01",
  //         endDate: null,
  //       },
  //       category: "Senior",
  //       position: "Ailier gauche",
  //       matchesPlayed: 85,
  //       goalsScored: 27,
  //       assists: 15,
  //     },
  //   ],
  // }

  if (getProfileLoading) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <Spinner color="primary" />
        <div>Chargement en cours...</div>
      </div>
    );
  }
  const styles = {
    container: {
      margin: "20px auto",
      backgroundColor: "#FBFBFB",
    },
    header: {
      fontSize: "16px",
      marginBottom: "10px",
      font: "Poppins",
    },
    details: {
      fontSize: "14px",
      color: "#555",
    },
    bold: {
      weight: 700,
      color: "black",
    },
    colTitle: {
      fontSize: "14px",
      color: "#000000",
      background: "F3F8F9",
    },
    colValue: {
      fontSize: "14px",
      color: "#555",
    },
    noResult: {
      backgroundColor: "#ededed",
      borderRadius: "8px",
      padding: "16px",
      fontSize: "16px",
      fontWeight: 600,
      fontFamily: "Open Sans",
      textAlign: "center",
      color: "#000",
      lineHeight: 1.4,
      marginTop: "20px",
    },
  };

  return (
    <>
      {player?.history &&
        (player.history.length > 0 ? (
          <>
            {player.history.map((entry, index) => (
              <Row style={styles.container} key={index}>
                {/* Titre principal */}
                <Col md={6}>
                  <Row>
                    <Col>
                      <div style={styles.header}>
                        <span style={styles.bold}>{entry.clubName} |</span>{" "}
                        {dayjs(entry.dateRange.startDate).format("YYYY")} -{" "}
                        {entry.dateRange.endDate
                          ? dayjs(entry.dateRange.endDate).format("YYYY")
                          : "/"}{" "}
                        | {entry.category}
                      </div>
                    </Col>
                  </Row>

                  {/* Détails */}
                  <Row style={{ marginTop: 12, paddingLeft: 12 }}>
                    {/* Colonne 1 : Poste */}
                    <Col>
                      <Row>
                        <Col style={styles.colTitle}>
                          {t("playerInfo.historique.position")}
                        </Col>
                      </Row>
                      <Row style={{ marginTop: 10 }}>
                        <Col style={styles.colValue}>{entry.position}</Col>
                      </Row>
                    </Col>

                    {/* Colonne 2 : Matchs joués */}
                    <Col>
                      <Row>
                        <Col style={styles.colTitle}>
                          {t("playerInfo.historique.matchesPlayed")}
                        </Col>
                      </Row>
                      <Row style={{ marginTop: 10 }}>
                        <Col style={styles.colValue}>{entry.matchesPlayed}</Col>
                      </Row>
                    </Col>

                    {/* Colonne 3 : Buts marqués */}
                    <Col>
                      <Row>
                        <Col style={styles.colTitle}>
                          {t("playerInfo.historique.goalsScored")}
                        </Col>
                      </Row>
                      <Row style={{ marginTop: 10 }}>
                        <Col style={styles.colValue}>{entry.goalsScored}</Col>
                      </Row>
                    </Col>

                    {/* Colonne 4 : Passes décisives */}
                    <Col>
                      <Row>
                        <Col style={styles.colTitle}>
                          {t("playerInfo.historique.assists")}
                        </Col>
                      </Row>
                      <Row style={{ marginTop: 10 }}>
                        <Col style={styles.colValue}>{entry.assists}</Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            ))}
          </>
        ) : (
          // 👉 Afficher le message s'il n'y a pas d'historique
          <p style={styles.noResult}>{t("playerInfo.historique.noHistory")}</p>
        ))}
    </>
  );
};

export default Historique;
